import { InputBase, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";
import MuiToggleButton from "@mui/material/ToggleButton";
import type { ToggleButtonProps } from "@mui/material/ToggleButton";

export const StyledSearch = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: "10px",
    border: "1px solid #7093a0",
    backgroundColor: alpha("#091920", 0.95),
    "&:hover": {
        backgroundColor: alpha("#091920", 0.45),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(0),
        width: "auto",
    },
}));

export const StyledSearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 1),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
        padding: theme.spacing(2, 1, 2, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        height: "5px",
        fontSize: "0.775rem",
        [theme.breakpoints.up("md")]: {
            width: "20ch",
        },
    },
}));

export const StyledFilterToggleButton = styled(
    MuiToggleButton
)<ToggleButtonProps>(() => ({
    // default state
    position: "relative" as const,
    overflow: "hidden",
    color: "#eaeaea",
    fontSize: "0.575rem",
    fontWeight: 400,
    fontFamily: "inherit",
    paddingBottom: "14px",

    // selected (and selected hover)
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "#eaeaea",
        fontSize: "0.638rem",
        fontWeight: 700,
        fontFamily: "inherit",
        background: "transparent",
    },

    // full-size gradient clipped to a 10px strip at the bottom
    "&.Mui-selected::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        clipPath: "inset(calc(100% - 10px) 0 0 0)",
        background: `radial-gradient(
        circle at 85% 15%,
        #23d1d4 0%,
        rgba(35, 209, 212, 0.8) 30%,
        transparent 60%
      ),
      radial-gradient(
        circle at 5% 95%,
        #091920 0%,
        rgba(35, 209, 212, 0.5) 20%,
        transparent 80%
      ),
      radial-gradient(
        circle at 85% 85%,
        #ffffff 0%,
        rgba(255, 255, 255, 0.9) 35%,
        transparent 65%
      )`,
    },
}));

export const StyledAlphaFilterToggleButton = styled(
    MuiToggleButton
)<ToggleButtonProps>(() => ({
    // default state
    color: "#eaeaea",
    fontSize: "0.775rem",
    fontWeight: 400,
    fontFamily: "inherit",

    // selected (and selected hover)
    "&.Mui-selected, &.Mui-selected:hover": {
        color: "#091920",
        fontSize: "0.850rem",
        fontWeight: 600,
        fontFamily: "inherit",
        background: `radial-gradient(
        circle at 85% 15%,
        #23d1d4 0%,
        rgba(35, 209, 212, 0.8) 30%,
        transparent 60%
      ),
      radial-gradient(
        circle at 5% 95%,
        #091920 0%,
        rgba(35, 209, 212, 0.5) 20%,
        transparent 80%
      ),
      radial-gradient(
        circle at 85% 85%,
        #ffffff 0%,
        rgba(255, 255, 255, 0.9) 35%,
        transparent 65%
      )`,
    },
}));
